// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"a5995c9b","526":"a5995c9b"}[chunkId] + ".chunk.css";
};